import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ModalHeader } from './modal-header';
/**
 * Header container for split modals. Spans both columns with consistent styling and bottom border.
 *
 * @example
 * ```tsx
 * <SplitModalHeader>
 *   <ModalTitle title="Settings" />
 *   <ModalCloseButton onClose={handleClose} />
 * </SplitModalHeader>
 * ```
 */
export const SplitModalHeader = ({ children, ...props }) => {
    return (_jsx(ModalHeader, { ...props, style: { gridArea: 'header' }, padding: "24px", borderBottom: "n100", children: children }));
};
